import { groupBy, isEmpty, stubTrue } from 'lodash-es';
import { FormattedMessage } from 'react-intl';

import {
  formatAccount,
  formatAccountFull,
} from '../../common/utils/formatUtils';
import { useAccounts } from '../../hooks/data/auth';
import { useAccountElementsStyles } from './accountElements.styles';

export function useAccountOptions({ filter = stubTrue } = {}) {
  const { styles } = useAccountElementsStyles();
  const { customerAccounts, error, loading } = useAccounts();
  const accountOptions = (customerAccounts || [])
    .filter(filter)
    .map(account => ({
      label: formatAccount(account),
      title: formatAccountFull(account),
      value: account,
    }));

  const { true: partnerOptions = [], false: nonPartnerOptions = [] } = groupBy(
    accountOptions,
    acc => acc.value.partner
  );

  const options = isEmpty(partnerOptions)
    ? nonPartnerOptions
    : [
        {
          key: 'partner',
          label: (
            <span className={styles.accountSelectGroupPartner}>
              <FormattedMessage id="accountSelect.options.partner" />
            </span>
          ),
          options: partnerOptions,
        },
        {
          key: 'non-partner',
          label: (
            <span className={styles.accountSelectGroupNonPartner}>
              <FormattedMessage id="accountSelect.options.nonPartner" />
            </span>
          ),
          options: nonPartnerOptions,
        },
      ];

  return { options, error, loading };
}
